import React from 'react';

/**
 * Conteúdo formatado dos Termos de Uso.
 * Renderiza o documento com tipografia e estrutura visual adequadas.
 */
export const TermsContent: React.FC = () => {
  return (
    <div className="prose prose-sm max-w-none text-muted-foreground leading-relaxed">
      <h2 className="text-lg font-bold text-foreground text-center mb-4">
        TERMOS DE USO - PLATAFORMA BRAVAFORTE
      </h2>

      <p className="font-medium text-foreground">Seja bem-vindo(a)!</p>

      <p>
        Somos a <strong>Bravaforte Capital Ltda.</strong>, plataforma especializada em conectar investidores
        qualificados com empreendimentos imobiliários selecionados, por meio de intermediação privada para
        apresentação de oportunidades de investimento em ativos da economia real lastreados em imóveis
        (&quot;Plataforma&quot;, &quot;Bravaforte&quot; ou &quot;Nós&quot;), inscrita no CNPJ n.º 55.548.910/0001-03.
      </p>

      <p>
        Ao utilizar nossos serviços, realizar o cadastro e acessar a Plataforma, você (&quot;Você&quot;,
        &quot;Investidor&quot; ou &quot;Usuário&quot;) declara estar integralmente de acordo com estes Termos
        de Uso da Plataforma Bravaforte (&quot;Termos&quot;), tendo compreendido e concordado com todas as suas cláusulas.
      </p>

      <p>
        A utilização da Plataforma e a manutenção do cadastro configuram aceite integral, irrestrito e irrevogável
        destes Termos, sendo o cumprimento de suas disposições indispensável para o acesso e uso da Plataforma.
      </p>

      <p>
        Caso tenha dúvida, fique à vontade para entrar em contato conosco — para Nós, é sempre um prazer lhe
        atender! Basta enviar uma mensagem ao nosso suporte por meio do nosso site{' '}
        <span className="font-medium">www.bravaforte.com</span> (&quot;Site&quot;).
      </p>

      {/* DEFINIÇÕES */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">DEFINIÇÕES</h3>
      <p>
        Todos os termos referidos com inicial maiúscula nestes Termos, incluindo o preâmbulo acima, seja no
        singular ou no plural, em ambos os gêneros, têm os significados atribuídos ao longo destes Termos
        entre parênteses e aspas.
      </p>

      {/* OBJETO E NATUREZA DA PLATAFORMA */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">OBJETO E NATUREZA DA PLATAFORMA</h3>
      <p>
        A Bravaforte concede ao Investidor licença limitada e temporária para uso da Plataforma
        (&quot;Licença&quot;), por meio da qual será possível realizar o cadastro, visualizar Empreendimentos
        aprovados, acessar Relatórios Conclusivos e acompanhar investimentos realizados.
      </p>
      <p>
        A Licença é onerosa, intransferível e não exclusiva, permanecendo válida durante a vigência deste Termo.
      </p>
      <p>
        A Bravaforte pode investigar reivindicações e violações que cheguem ao seu conhecimento e pode tomar
        quaisquer medidas que julgar apropriadas, incluindo, entre outras, emissão de avisos, suspensão dos
        serviços e de acesso à Plataforma.
      </p>
      <p>
        Caso seja constatado, ou haja suspeita, de que o Investidor tenha feito uso indevido da Plataforma,
        a Bravaforte notificará o Investidor para que ele se manifeste sobre o fato em até 10 (dez) dias
        contados da notificação. Em caso de silêncio ou ausência de justificativa plausível, a Bravaforte
        poderá, a seu critério e por medida de segurança, suspender imediatamente o acesso do Investidor.
      </p>
      <p>
        A Bravaforte pode, a qualquer momento, fazer alterações, melhorias de funcionamento, correções e
        inclusão de novos recursos na Plataforma.
      </p>
      <p>
        A Bravaforte empregará os melhores esforços em relação aos serviços e à Plataforma. No caso de
        interrupção do funcionamento da Plataforma, a Bravaforte se compromete a tomar as medidas necessárias
        para restabelecer o adequado funcionamento, no menor prazo possível.
      </p>

      {/* CADASTRO */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">CADASTRO</h3>
      <p>
        Para utilizar a Plataforma, o Investidor ou o Incorporador (&quot;Usuário&quot;) deverá realizar um
        cadastro (&quot;Cadastro&quot;), informando nome completo ou razão social, CPF ou CNPJ, e-mail,
        telefone celular e demais informações solicitadas.
      </p>
      <p>
        As informações fornecidas no Cadastro são de responsabilidade do Usuário e deverão ser corretas,
        verdadeiras e completas. O login criado no Cadastro é pessoal e intransferível.
      </p>
      <p>
        O Usuário compromete-se a manter seus dados cadastrais sempre atualizados, comunicando à Bravaforte
        qualquer alteração em seus dados pessoais, especialmente e-mail e telefone, com antecedência mínima
        de 5 (cinco) dias úteis.
      </p>
      <p>
        A Bravaforte se reserva o direito de recusar qualquer solicitação de Cadastro e de suspender qualquer
        Cadastro previamente efetuado que esteja em desacordo com estes Termos ou com a legislação aplicável.
      </p>

      {/* SERVIÇOS */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">SERVIÇOS FORNECIDOS PELA BRAVAFORTE</h3>
      <p>Por meio da Plataforma, a Bravaforte disponibiliza ao Investidor os seguintes serviços:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>Visualização de Empreendimentos imobiliários aprovados no processo de Diligência;</li>
        <li>Acesso ao Relatório Conclusivo de cada Empreendimento;</li>
        <li>Visualização da constatação documental das Garantias;</li>
        <li>Acesso às Fichas Técnicas de cada Empreendimento;</li>
        <li>Área restrita para acompanhamento dos investimentos realizados;</li>
        <li>Gestão consolidada de carteira de investimentos;</li>
        <li>Disponibilização e atualização das informações dos Empreendimentos;</li>
        <li>Suporte e atendimento ao Investidor.</li>
      </ul>
      <p>
        A Bravaforte não se responsabiliza pela veracidade, integridade, atualização ou completude das
        informações fornecidas pelos Incorporadores.
      </p>

      {/* DILIGÊNCIA */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">DILIGÊNCIA E RELATÓRIO CONCLUSIVO</h3>
      <p>
        A Diligência realizada pela Bravaforte compreende um processo estruturado de análise dos
        Empreendimentos, executada em duas fases distintas:
      </p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Fase 1 - Pré-Análise:</strong> análise de viabilidade técnica e econômica;</li>
        <li><strong>Fase 2 - Análise Conclusiva:</strong> análise mercadológica, jurídica e contábil.</li>
      </ul>
      <p>O Relatório Conclusivo possui caráter estritamente informativo, <strong>não representando:</strong></p>
      <ul className="list-disc pl-5 space-y-1">
        <li>Garantia de retorno, viabilidade ou sucesso do Empreendimento;</li>
        <li>Recomendação de investimento;</li>
        <li>Auditoria independente;</li>
        <li>Validação jurídica ou contábil das informações;</li>
        <li>Certificação ou chancela da Bravaforte.</li>
      </ul>
      <p>
        O Investidor deve analisar de forma independente a adequação das Garantias, consultando profissionais
        especializados. A decisão de investir é de exclusiva responsabilidade do Investidor.
      </p>

      {/* INVESTIMENTOS */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">INVESTIMENTOS</h3>
      <p>
        Cada Empreendimento será identificado por uma Ficha Técnica específica contendo dados técnicos,
        condições comerciais e demais condições aplicáveis. O Investidor poderá investir em múltiplos
        Empreendimentos, devendo aceitar individualmente a Ficha Técnica de cada um.
      </p>
      <p>
        Em caso de conflito entre estes Termos e as condições comerciais específicas, prevalecerá o
        disposto nas condições específicas do Empreendimento.
      </p>

      {/* REMUNERAÇÃO */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">REMUNERAÇÃO DA BRAVAFORTE</h3>
      <p>A Bravaforte opera com modelo de remuneração dual:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Remuneração paga pelo Incorporador:</strong> taxa de intermediação e captação de recursos;</li>
        <li><strong>Remuneração paga pelo Investidor:</strong> taxas de disponibilização, organização e acompanhamento.</li>
      </ul>
      <p>
        A Remuneração paga pelo Investidor consistirá em: Taxa de Acesso e Uso da Plataforma, Taxa de
        Acompanhamento do Investimento e outras taxas conforme especificado para cada Empreendimento.
      </p>

      {/* RESPONSABILIDADES */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">RESPONSABILIDADES DOS USUÁRIOS</h3>
      <p>Os Investidores declaram ser exclusivamente responsáveis por:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>Decisão de investimento: analisar de forma independente e decidir por sua conta e risco;</li>
        <li>Análise complementar: realizar sua própria diligência complementar;</li>
        <li>Análise de Garantias: avaliar de forma independente;</li>
        <li>Veracidade de informações: manter dados atualizados;</li>
        <li>Sigilo e segurança: manter a segurança de suas credenciais;</li>
        <li>Cumprimento dos Termos: observar integralmente estes Termos.</li>
      </ul>
      <p>O Investidor reconhece expressamente que:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>A Bravaforte não valida juridicamente as Garantias;</li>
        <li>O Relatório Conclusivo possui caráter estritamente informativo;</li>
        <li>A SCP é constituída diretamente entre o Investidor e o Incorporador;</li>
        <li>A decisão de investir e todos os riscos são de sua exclusiva responsabilidade;</li>
        <li>A Bravaforte não se responsabiliza por perdas ou desempenho financeiro inferior ao projetado.</li>
      </ul>

      {/* ISENÇÕES */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">ISENÇÕES E LIMITAÇÕES DE RESPONSABILIDADE</h3>
      <p>A Bravaforte não se responsabiliza por:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>Decisões de investimento tomadas pelos Investidores;</li>
        <li>Desempenho financeiro, rentabilidade ou resultado dos Empreendimentos;</li>
        <li>Inadimplemento ou descumprimento por parte dos Incorporadores;</li>
        <li>Vícios construtivos, atrasos ou não conclusão dos Empreendimentos;</li>
        <li>Constituição irregular ou dissolução da SCP;</li>
        <li>Problemas técnicos, interrupções ou falhas da Plataforma por caso fortuito ou força maior;</li>
        <li>Uso indevido da Plataforma por parte dos Usuários;</li>
        <li>Danos indiretos, lucros cessantes ou perda de oportunidade.</li>
      </ul>
      <p>
        A responsabilidade da Bravaforte ficará limitada à Remuneração paga pelo Investidor relativa ao
        Empreendimento que deu causa ao evento danoso.
      </p>

      {/* VIGÊNCIA E RESCISÃO */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">VIGÊNCIA E RESCISÃO</h3>
      <p>
        Estes Termos têm vigência por prazo indeterminado. O Usuário poderá rescindir a qualquer momento,
        mediante comunicação por e-mail à Bravaforte. A rescisão não afeta os investimentos já realizados.
      </p>
      <p>
        A Bravaforte poderá excluir o Cadastro do Investidor que não possua investimentos ativos e que
        não tenha acessado a Plataforma por período superior a 180 dias consecutivos, mediante comunicação
        prévia de 30 dias.
      </p>

      {/* MODIFICAÇÕES */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">MODIFICAÇÕES DOS TERMOS</h3>
      <p>
        A Bravaforte poderá alterar, a qualquer tempo, estes Termos. Os novos Termos entrarão em vigor
        30 (trinta) dias após sua publicação na Plataforma ou envio por e-mail.
      </p>

      {/* PRIVACIDADE */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">PRIVACIDADE</h3>
      <p>
        O tratamento dos dados será regido pela Lei Geral de Proteção de Dados (Lei n.º 13.709/2018).
      </p>

      {/* PROPRIEDADE INTELECTUAL */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">PROPRIEDADE INTELECTUAL</h3>
      <p>
        Somos detentores exclusivos dos direitos de propriedade intelectual sobre a marca e os elementos
        da Plataforma. É vedado aos Usuários modificar, reproduzir, distribuir ou criar trabalhos derivados
        baseados na Plataforma, exceto quando expressamente autorizado por escrito.
      </p>

      {/* ANTICORRUPÇÃO */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">ANTICORRUPÇÃO</h3>
      <p>
        A Bravaforte e os Usuários comprometem-se a atuar em conformidade com a legislação anticorrupção
        aplicável, incluindo as Leis n.º 12.846/13 e n.º 8.429/1992.
      </p>

      {/* FORO */}
      <h3 className="text-base font-bold text-foreground mt-6 mb-2">LEGISLAÇÃO APLICÁVEL E FORO DE ELEIÇÃO</h3>
      <p>
        Estes Termos são regidos de acordo com as leis da República Federativa do Brasil. Fica eleito o
        foro da Comarca de São Paulo/SP para dirimir quaisquer litígios decorrentes destes Termos de Uso.
      </p>

      <p className="text-center font-medium text-foreground mt-6">
        Última atualização em fevereiro de 2026.
      </p>
      <p className="text-center font-medium text-foreground">Equipe Bravaforte</p>
    </div>
  );
};
